import React from 'react';

export function showToast(msg: string) {
  const el = document.createElement('div');
  el.className =
    'fixed bottom-5 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-lg bg-gray-900 text-white dark:bg-white dark:text-gray-900 shadow-soft';
  el.textContent = msg;
  document.body.appendChild(el);
  setTimeout(() => { el.remove(); }, 2000);
}
